import {
  GGOBaseComponent,
  RESTUtils,
  Router,
  Route,
  Translate,
  SpinnerComponent,
} from '@galigeo-store/ui-lib';
import { css, html, PropertyValues } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { PortalAppContext } from '../../state/portal-appcontext.js';
import { PUBSUB_TOPICS, subscribe, unsubscribe } from '../../state/pubsub.js';
import '../admin/admin.component.js';
import '../admin/general/logs.admin.component.js';
import { publish } from 'pubsub-js';

@customElement('right-panel')
export class RightPanel extends GGOBaseComponent {
  private router: Router | undefined;
  @property({ type: Array }) elements: Array<any> = [];
  @property({ type: String }) route: string = '';
  @property({ type: Object }) selectedItem: any = {};
  @property({ type: Boolean }) showSpinner = false;

  static get styles() {
    return [
      ...super.styles,
      css`
        .home-page {
          background: var(--slds-c-button__icon-background-color);
          font-size: 1.5rem;
          font-weight: bold;
          color: var(--slds-c-button__icon-color);
          padding: 1rem;
          border-radius: 0.5rem;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          margin: 1rem;
          text-align: center;
          transition: background-color 0.3s ease;
        }
        ggo-spinner {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 1000;
        }
        .container {
          margin: 3rem;
        }
        .home-page-title {
          font-size: 1.5rem;
          text-align: left  ;
          margin-bottom: 1rem;
        }
      `,
    ];
  }

  constructor() {
    super();
    subscribe(PUBSUB_TOPICS.REFRESH_IFRAME, () => {
      this.requestUpdate();
    });
  }

  handleMenuClick() {
    console.log('handleMenuClick', this.selectedItem);

    if (this.router !== undefined) {
      let finalRoute = this.route ?? '';

      if (this.selectedItem?.categoryId) {
        if (!this.route.includes('viewerId')) {
          finalRoute += `?viewerId=${this.selectedItem.id}`;
        }
      }

      this.router.loadRoute(finalRoute);
    }
  }

  protected updated(changedProperties: PropertyValues): void {
    if (changedProperties.has('selectedItem')) {
      this.showSpinner = true;
      if (!this.router) {
        this.setRoutes();
      }
      this.handleMenuClick();
    } else {
      const urlParams = new URLSearchParams(window.location.hash);
      console.log('URL Params:', urlParams.toString());
    }
  }

  setRoutes() {
    if (this.router === undefined) {
      const routes: Route[] = [
        {
          path: '',
          callback: () => {
            console.log('Default route callback');
          },
        },
        {
          path: 'admin',
          callback: () => {
            console.log('Admin route callback');
          },
        },
        {
          path: 'others',
          callback: () => {
            console.log('Other route callback');
          },
        },
      ];
      for (let element of this.elements) {
        routes.push({
          path: element.type ?? element.id,
          callback: () => {
            console.log('Route callback for', element.type ?? element.id);
          },
        });
      }
      this.router = new Router(routes, true);
    }
  }

  handleIframeLoad(event: Event) {
    this.showSpinner = false;
    console.log('Iframe loaded');
    const iframe = event.target as HTMLIFrameElement;
    if (iframe?.contentWindow) {
      const message = {
        user: PortalAppContext.getCurrentUser(),
      };
      const targetOrigin = new URL(iframe.src).origin;
      iframe.contentWindow.postMessage(message, targetOrigin);
      console.log('Message posted to iframe:', message);

      this.detectIframeUrlChanges(iframe);
    }
  }

  detectIframeUrlChanges(iframe: HTMLIFrameElement) {
    window.addEventListener('message', (event) => {
      console.log('Message received from iframe:', event.data);
      const iframeOrigin = new URL(iframe.src).origin;
      if (event.origin === iframeOrigin && event.data.type === 'urlChange') {
        const iframeurl = new URL(event.data.url);
        let iframepath = iframeurl.pathname;
        const urlParams = iframeurl.search;
        const currentUrl = new URL(window.location.href);
        if (iframepath.startsWith('/')) {
          iframepath = iframepath.substring(1);
        }
        if (iframepath.endsWith('/')) {
          iframepath = iframepath.substring(0, iframepath.length - 1);
        }
        const newUrl = currentUrl.origin + '#' + iframepath;
        console.log('New URL:', newUrl);
        this.router?.loadRoute(iframepath + urlParams);
        window.removeEventListener('message', () => {
          console.log('Message listener removed');
        });
      }
    });
  }

  render() {
    subscribe(PUBSUB_TOPICS.GO_HOME, () => {
      this.selectedItem = undefined;
      this.route = '';
      this.router?.loadRoute('');
      this.requestUpdate();
      unsubscribe(PUBSUB_TOPICS.GO_HOME);
    });
    this.setRoutes();
    if (this.route === 'admin') {
      document.title = 'Administration';
      return html`<admin-page></admin-page>`;
    }
    if (PortalAppContext.isLicenseExpired()) {
      return html`
        <div class="container" style="text-align: center; margin-top: 5rem;">
          <ggo-icon icon="utility:lock" size="large" color="#c23934"></ggo-icon>
          <h2 style="margin-top: 1rem; color: #c23934;">${Translate.get('lic_expired')}</h2>
          <p style="margin-top: 0.5rem; color: #666;">${Translate.get('lic_blocked_message')}</p>
        </div>
      `;
    }
    if (!this.selectedItem) {
      return html`
      <div class="container">
        <div class="home-page-title">${Translate.get('home_page')}</div>
          <div
            style="display: flex; flex-wrap: wrap; gap: 1rem; max-width: 1000px"
          >
          ${this.elements.map((item) => {
        return html`<ggo-card-button
                style="height: 250px; width: 300px;"
                title="${item.label}"
                icon="${item.icon}"
                bgColor="${item.color ?? '#d8e6fe'}"
                @start="${(event: any) => {
            publish(PUBSUB_TOPICS.MENU_CLICKED, { element: item, event });
          }}"
            >${item.description}</ggo-card-button
          >`;
      })}
        <ggo-card-button
          style="height: 250px; width: 300px;"
          title="${Translate.get('others')}"
          icon="/svg/icons.svg#others"
          bgColor="#e5e5e5"
          @start="${(event: any) => {
          publish(PUBSUB_TOPICS.PLUS_BTN_CLICKED, {
            clickedElement: {
              id: 'others',
              event,
            }
          });
        }}"
          >${Translate.get('others_description')}</ggo-card-button
        >
      </div>
      </div>`;
    }
    if (!this.selectedItem.categoryId && !this.route) {
      this.route = 'others';
      this.selectedItem.categoryId = 'others';
    }
    if (this.selectedItem.url === '' || this.selectedItem.url === undefined) {
      return html`<div class="slds-text-align_center slds-m-around_medium">
        Module ${this.selectedItem.label} is not ready yet
      </div>`;
    }

    let url = this.getIframeUrl();

    document.title = this.selectedItem.label;

    url = RESTUtils.setUrlParameter(url, 'ggo_token', RESTUtils.getToken());
    //url = RESTUtils.setUrlParameter(url, 'crossDomain', 'true');
    url = RESTUtils.setUrlParameter(
      url,
      'lang',
      PortalAppContext.getCurrentUser().lang,
    );
    if (this.selectedItem.type) {
      url = RESTUtils.setUrlParameter(url, 'module', this.selectedItem.type);
    }

    return html`
      ${this.showSpinner ? html`<ggo-spinner size="large"></ggo-spinner>` : ''}
      <iframe
        src="${url}"
        style="border: none"
        @load="${this.handleIframeLoad}"
        width="100%"
        height="100%"
      ></iframe>
    `;
  }

  getIframeUrl() {
    const index = this.route.indexOf('/');
    const r = index !== -1 ? this.route.slice(index + 1) : '';
    console.log('getIframeUrl', this.selectedItem.url, r);
    const url = new URL(this.selectedItem.url);
    return url.origin + url.pathname + r + url.search;
  }
}
